export const BROKER_QUALITY_SCORECARD_LOANS_URL = '/api/command-center/quality-scorecard-metrics';

export const DEFAULT_QUALITY_SCORECARD_WINDOW_DAYS = 90;
